// CẦU NỐI trang Kịch bản ↔ canvas sơ đồ nhiều mạng (GĐ-A/B1 lượt 2, 07/10/2026) — PHẦN THUẦN (không DOM, không mạng): đổi dữ liệu máy chủ sang dữ liệu canvas, thao tác thuần trên đồ thị,
// cờ theo ô / theo đoạn, kế hoạch dự kiến, HÀNG ĐỢI LƯU đồ thị (lạc quan, gom thao tác cùng nhịp, tuần tự, 400 / 409 / mất mạng khôi phục), lưu BỐ CỤC có debounce, chữ của thẻ lượt.
// Trang (pages/kich-ban-do-thi.ts, kich-ban-luot.ts) chỉ gọi các hàm này rồi vẽ. Mọi hàm KHÔNG ném với đầu vào xấu (từ chối bằng null) và không sinh NaN.
import { nhanNhanh } from "../../../src/shared/ten-ma-noi-bo";
import { chuanHoaCanh, chuanHoaLap, chuLapCaSoDo, chuUoc, heSoVong, soDuong, tachDuong, canhMacDinh } from "./so-do-canvas-mo-hinh";
import { GIOI_HAN_DO_THI, bungVong, soVongCaSoDo, type CanhDoThi, type CanhLap, type LapCaSoDo, type MucKeHoach, type NutDoThi } from "../../../src/shared/do-thi";
import { moTaThaoTac, nutKeCua, themNut, thieuThamSoCua, type ThamSoThieuDef } from "../../../src/shared/so-do-sua";
import { nhanLan } from "../../../src/shared/lan-dung";

// ================= KIỂU =================
export interface ThamSoBanDo { ten: string; nhan: string; moTa: string; kieu: "chuoi" | "so"; batBuoc?: boolean; macDinh?: string; goiY?: string; min?: number; max?: number; luaChon?: string[] }
export interface ThaoTacBanDo { ma: string; tenNgan: string; moTa: string; mauMoTa: string; bieuTuong: string; ruiRo: "cao" | "thap"; thamSo: ThamSoBanDo[]; thuTu: { nghi: boolean } }
export interface MangBanDo { ma: string; ten: string; thaoTac: ThaoTacBanDo[] }
export interface BanDoWeb { nenTang: MangBanDo[] }

export type KqChayThu = "chua" | "sach" | "loi" | "cu" | "dang";
export interface ChayThuSv { ketQua: KqChayThu; luc: string | null; botTen: string[]; lyDo: string | null; duocChayThat: boolean }
export interface MucDoanSv { kieu: "doan"; doanId: string; kichBanId: string; nutDau: string; nenTang: string; nutIds: string[]; thuTu: number; uocS?: number; bundleHash: string | null; chayThu: ChayThuSv }
export interface MucNghiSv { kieu: "nghi"; tuS: number; denS: number; nutId: string }
/** (07/10/2026) Mục "quay lại" của vòng lặp (kế hoạch dự kiến). */
export interface MucLapSv { kieu: "lap"; veMuc: number; soLan: number; denGio?: string; tu: string; den: string; denHetNghi?: boolean }
export type MucSv = MucDoanSv | MucNghiSv | MucLapSv;
export interface DuongSv { id: string; muc: MucSv[] }
export interface KeHoachSv { duong: DuongSv[]; lapCaSoDo?: { soVong: number; tuS: number; denS: number; denGio?: string } }
export interface KetQuaNutSv { trangThai: "ok" | "loi" | "nhap" | "bo_qua" | "chua"; lyDo?: string; cauMau: string[]; cauDaSua?: string[] }
export interface CanhBaoBuocSv { nutId: string; soThuTu: number; muc: "vang" | "do"; ma: string; loi: string; doanId?: string; soDoan?: number }
export interface ThieuDauVaoSv { nutId: string; soThuTu: number; tenNgan: string; ma: string; lyDo: string; doanId?: string; soDoan?: number }
export interface CanhBaoDoThiSv { loai: string; nutId?: string; nutAnhHuong?: string; lyDo: string; cachSua?: string }
export interface CanhBaoDoanSv { doanId: string; nutId?: string; loai: string; noi: string }
export interface SoDoSv { id: string; ten: string; yeuCau: string; nenTang: string; nut: NutDoThi[]; canh?: CanhDoThi[]; nutKe?: number }
export interface ChiTietDoThiSv {
  id: string;
  ownerId?: string;
  phienBan: number;
  chiDoc?: boolean;
  /** Đồ thị đơn (một đường, một mạng, không vòng lặp) — không cần cờ thử nghiệm nhiều mạng. */
  doThiDon?: boolean;
  loiSoDo?: string[];
  soDo: SoDoSv | null;
  doThi: {
    nenTang: string; mang: string[]; soNut: number; soDuong: number; soDoan: number; canh: CanhDoThi[] | null; nut: NutDoThi[]; keHoach: KeHoachSv | null; ketQuaNut: Record<string, KetQuaNutSv>; lechCon: { thieu: string[]; thua: string[] };
    /** (07/10/2026) vòng lặp + lặp cả sơ đồ + ước lượng giây theo ô (máy chủ cũ có thể thiếu). */
    lap?: CanhLap[]; lapCaSoDo?: LapCaSoDo | null; uocNut?: Record<string, { tuS: number; denS: number }>;
  };
  canhBaoBuoc?: CanhBaoBuocSv[];
  thieuDauVao?: ThieuDauVaoSv[];
  canhBaoDoThi?: CanhBaoDoThiSv[];
  canhBaoDoan?: CanhBaoDoanSv[];
  boCuc?: { nut: Record<string, { x: number; y: number; rong?: number; cao?: number }>; capNhatLuc: string };
}
/** Một cờ của ô (cùng dạng CanhBaoNut của canvas: `loi` là câu hiện cho người dùng). */
export interface CoNut { muc: "vang" | "do"; loi: string }
/** Trạng thái đồ thị trên TRANG: nút + cạnh (tường minh) + mạng mặc định + bộ đếm mã nút kế tiếp (chỉ ở trang, không gửi máy chủ). */
export interface TrangDoThi { nut: NutDoThi[]; canh: CanhDoThi[]; nenTang: string; nutKe?: number; lap?: CanhLap[]; lapCaSoDo?: LapCaSoDo | null }
export type ViTriBoCuc = { x: number; y: number };
export type BoCucTrang = Record<string, ViTriBoCuc>;

const sao = <T>(v: T): T => structuredClone(v);
const hh = (v: unknown): v is number => typeof v === "number" && Number.isFinite(v);

// ================= BẢN ĐỒ =================
export const mangCua = (banDo: BanDoWeb | null | undefined, ma: string): MangBanDo | undefined => banDo?.nenTang.find((n) => n.ma === ma);
export const tenMangCua = (banDo: BanDoWeb | null | undefined, ma: string): string => mangCua(banDo, ma)?.ten ?? (ma || "");
export const thaoTacCua = (banDo: BanDoWeb | null | undefined, nenTangNut: string, thaoTac: string): ThaoTacBanDo | undefined => mangCua(banDo, nenTangNut)?.thaoTac.find((t) => t.ma === thaoTac);
const mangNut = (n: NutDoThi, macDinh: string): string => n.nenTang ?? macDinh;
export const laNghiCua = (banDo: BanDoWeb | null | undefined, macDinh: string, n: NutDoThi): boolean => thaoTacCua(banDo, mangNut(n, macDinh), n.thaoTac)?.thuTu.nghi ?? n.thaoTac === "nghi";
/** Tên ô = tên ngắn của thao tác (chưa kèm "lần n" — canvas hiện lần ở nhãn riêng). */
export const tenNutCua = (banDo: BanDoWeb | null | undefined, macDinh: string, n: NutDoThi): string => thaoTacCua(banDo, mangNut(n, macDinh), n.thaoTac)?.tenNgan ?? n.thaoTac;
export const tomTatNutCua = (banDo: BanDoWeb | null | undefined, macDinh: string, n: NutDoThi): string => {
  const t = thaoTacCua(banDo, mangNut(n, macDinh), n.thaoTac);
  return t ? moTaThaoTac(t, n.thamSo) : "";
};
/** Danh mục cho menu "Thêm ô" của canvas (mạng → thao tác). */
export const danhMucTuBanDo = (banDo: BanDoWeb | null | undefined): { nenTang: string; ten: string; thaoTac: { ma: string; ten: string }[] }[] =>
  (banDo?.nenTang ?? []).map((m) => ({ nenTang: m.ma, ten: m.ten, thaoTac: m.thaoTac.map((t) => ({ ma: t.ma, ten: t.tenNgan })) }));
/** Giá trị điền sẵn khi thêm ô mới: mặc định của bản đồ → số gợi ý → số nhỏ nhất (ô số) → rỗng (như bảng thêm bước ở kịch bản một đường). */
export function thamSoMacDinhCua(t: ThaoTacBanDo): Record<string, string> {
  return Object.fromEntries(t.thamSo.map((p) => [p.ten, p.macDinh ?? p.goiY ?? (p.kieu === "so" ? String(p.min ?? 1) : "")]));
}
/** Ô bắt buộc còn trống của một ô (dùng để tự mở form chi tiết cho ô mới thêm). */
export function thamSoThieuCua(banDo: BanDoWeb | null | undefined, macDinh: string, n: NutDoThi): { ten: string; nhan: string; lyDo: string }[] {
  const t = thaoTacCua(banDo, mangNut(n, macDinh), n.thaoTac);
  return t ? thieuThamSoCua(t.thamSo as ThamSoThieuDef[], n.thamSo) : [];
}

// ================= DỮ LIỆU MÁY CHỦ → TRANG =================
export function trangTuMayChu(d: Pick<ChiTietDoThiSv, "doThi" | "soDo">): TrangDoThi {
  const nut = sao(d.doThi.nut);
  const canh = d.doThi.canh ? sao(d.doThi.canh) : canhMacDinh(nut);
  const ke = d.soDo?.nutKe;
  return { nut, canh, nenTang: d.doThi.nenTang, ...(ke !== undefined && ke > 1 ? { nutKe: ke } : {}), lap: sao(d.doThi.lap ?? []), lapCaSoDo: d.doThi.lapCaSoDo ? { ...d.doThi.lapCaSoDo } : null };
}
/** Thân `doThi` gửi PUT (không có bộ đếm mã, không có vị trí — bố cục đi đường riêng). */
export const thanDoThiGui = (t: TrangDoThi): { nut: NutDoThi[]; canh: CanhDoThi[]; nenTang: string } => ({ nut: sao(t.nut), canh: sao(t.canh), nenTang: t.nenTang });
/** (07/10/2026) Thân PUT của canvas = thanDoThiGui + `lap` ([] = không vòng) + `lapCaSoDo` (null = không lặp cả sơ đồ) — để máy chủ bỏ vòng người dùng vừa gỡ. */
export const thanDoThiGuiCoVong = (t: TrangDoThi): { nut: NutDoThi[]; canh: CanhDoThi[]; nenTang: string; lap: CanhLap[]; lapCaSoDo: LapCaSoDo | null } => ({ ...thanDoThiGui(t), lap: sao(t.lap ?? []), lapCaSoDo: t.lapCaSoDo ? { ...t.lapCaSoDo } : null });
export const trangBangNhau = (a: TrangDoThi, b: TrangDoThi): boolean => a.nenTang === b.nenTang && JSON.stringify(a.nut) === JSON.stringify(b.nut) && JSON.stringify(a.canh) === JSON.stringify(b.canh)
  && JSON.stringify(a.lap ?? []) === JSON.stringify(b.lap ?? []) && JSON.stringify(a.lapCaSoDo ?? null) === JSON.stringify(b.lapCaSoDo ?? null);
export const boCucTuMayChu = (d: Pick<ChiTietDoThiSv, "boCuc">): BoCucTrang => Object.fromEntries(Object.entries(d.boCuc?.nut ?? {}).filter(([, p]) => hh(p?.x) && hh(p?.y)).map(([id, p]) => [id, { x: p.x, y: p.y }]));
/** Chỉ đọc khi máy chủ KHÔNG báo coDoThi (cờ tắt, trừ Super) hoặc kịch bản báo chiDoc. Người xem được trang là chủ kịch bản hoặc Super (máy chủ đã lọc), nên không kiểm chủ ở đây. */
// (07/10/2026, chỉ còn sơ đồ) đồ thị ĐƠN (một đường một mạng — dạng thường của mọi kịch bản; máy chủ báo doThiDon) sửa / chạy được dù cờ "nhiều mạng" tắt.
export const chiDocCua = (user: { role?: string; coDoThi?: boolean } | null | undefined, d: { chiDoc?: boolean; doThiDon?: boolean }): boolean => d.chiDoc === true || (user?.coDoThi !== true && d.doThiDon !== true);

// ================= THAO TÁC THUẦN TRÊN TRANG (null = không áp được) =================
const khongDoi = (a: TrangDoThi, b: TrangDoThi): boolean => trangBangNhau(a, b);
export function dtThemNut(t: TrangDoThi, nut: NutDoThi): TrangDoThi | null {
  if (!nut || typeof nut.id !== "string" || !nut.id || t.nut.some((n) => n.id === nut.id) || t.nut.length >= GIOI_HAN_DO_THI.nut) return null;
  const nuts = [...sao(t.nut), sao(nut)];
  return { ...t, nut: nuts, canh: sao(t.canh), nutKe: nutKeCua({ nut: nuts, nutKe: t.nutKe }) };
}
export function dtXoaNut(t: TrangDoThi, id: string): TrangDoThi | null {
  if (!t.nut.some((n) => n.id === id)) return null;
  // (đợt A) bước Nghỉ đang "dành cho" bước bị xoá → trỏ sang bước kế (hoặc trước) CÙNG nhánh; nhánh hết bước → bỏ "dành cho"
  const thay = t.canh.find((c) => c.tu === id)?.den ?? t.canh.find((c) => c.den === id)?.tu ?? null;
  const nutCon = t.nut.filter((n) => n.id !== id).map((n) => { if (n.danhCho !== id) return n; const { danhCho: _b, ...x } = n; return thay ? { ...x, danhCho: thay } : x; });
  return { ...t, nut: sao(nutCon), canh: sao(t.canh.filter((c) => c.tu !== id && c.den !== id)), lap: sao((t.lap ?? []).filter((c) => c.tu !== id && c.den !== id)), nutKe: nutKeCua({ nut: t.nut, nutKe: t.nutKe }) };
}
/** Đặt danh sách vòng lặp (chuẩn hoá: vòng sai bị bỏ). Không đổi → null. */
export function dtDatLap(t: TrangDoThi, lap: CanhLap[]): TrangDoThi | null {
  const moi = { ...t, lap: chuanHoaLap(t.nut, t.canh, lap).lap };
  return khongDoi(t, moi) ? null : moi;
}
/** Đặt / bỏ (null) "lặp cả sơ đồ". Không đổi → null. */
export function dtDatLapCaSoDo(t: TrangDoThi, lc: LapCaSoDo | null): TrangDoThi | null {
  const moi = { ...t, lapCaSoDo: lc ? { ...lc } : null };
  return khongDoi(t, moi) ? null : moi;
}
/** Hệ số nhân theo ô = tích (số lần lặp thêm + 1) của mọi vòng chứa ô đó (ước lượng "~45 giây ×3"). */
/**
 * (07/10/2026) Ước lượng giây của MỘT lần chạy ô cho canvas: ô Nghỉ tính NGAY từ tham số đang hiện (tu_giay / den_giay, hoặc giay_nghi; thiếu / không phải số → mặc định bản đồ) — đổi tham số thấy liền;
 * ô việc lấy từ máy chủ (doThi.uocNut — bộ ước lượng uocTheoNut trên bản dịch thật), cập nhật khi lưu xong. Không có → null.
 */
export function uocNutHienThi(t: Pick<TrangDoThi, "nenTang"> | null, d: Pick<ChiTietDoThiSv, "doThi">, banDo: BanDoWeb | null | undefined, n: NutDoThi): { tuS: number; denS: number } | null {
  const mac = t?.nenTang ?? d.doThi.nenTang;
  const op = thaoTacCua(banDo, mangNut(n, mac), n.thaoTac);
  if (op?.thuTu.nghi) {
    const so = (ten: string): number | undefined => {
      const def = op.thamSo.find((x) => x.ten === ten);
      if (!def) return undefined;
      const v = (n.thamSo[ten] ?? "").trim(), x = v === "" ? NaN : Number(v);
      if (Number.isFinite(x) && x >= 0) return x;
      const m = Number(def.macDinh);
      return Number.isFinite(m) && m >= 0 ? m : 0;
    };
    const a = so("tu_giay") ?? so("giay_nghi") ?? 0, b = so("den_giay") ?? so("giay_nghi") ?? a;
    return { tuS: Math.min(a, b), denS: Math.max(a, b) };
  }
  const u = d.doThi.uocNut?.[n.id];
  return u && hh(u.tuS) && hh(u.denS) ? { tuS: u.tuS, denS: u.denS } : null;
}
export const heSoVongNut =(t: Pick<TrangDoThi, "nut" | "canh" | "lap">): Map<string, number> => heSoVong(t.nut, t.canh, t.lap);
export { chuLapCaSoDo };
/**
 * TỔNG thời gian ước chừng của một lượt (như bộ điều phối: MỘT bot làm một đoạn một lúc; đường đang Nghỉ thì đường khác chen vào; vòng lặp bung đúng thứ tự; lặp cả sơ đồ + nghỉ giữa vòng).
 * Mức dưới dùng nghỉ "từ", mức trên nghỉ "đến"; đoạn dùng uocS (thiếu = 0). Nháp: nghỉ ×0,1, rút còn ≤ 2 vòng. Không NaN.
 */
export function uocTongSoDo(kh: { duong: DuongSv[]; lapCaSoDo?: { soVong: number; tuS: number; denS: number } }, o: { nhap?: boolean } = {}): { tuS: number; denS: number } {
  const nhap = o.nhap === true;
  const he = nhap ? 0.1 : 1;
  const mot = (tren: boolean): number => {
    // (08/10/2026) vòng "lặp tới khi hết bước Nghỉ": số vòng do phần Nghỉ dành cho nhánh quyết (chạy TRONG Nghỉ của nhánh chủ) — tính một vòng, không nhân soLan.
    const duong = kh.duong.map((du) => { const muc = du.muc.map((m) => (m.kieu === "lap" && m.denHetNghi ? { ...m, soLan: 0 } : m)); return { ds: bungVong(muc as MucKeHoach[], { nhap }).map((b) => muc[b.chiSo]!), i: 0, san: 0 }; });
    let bot = 0;
    for (let guard = 0; guard < 100_000; guard++) {
      // nghỉ chạy song song (bot rảnh): đẩy mốc sẵn sàng qua các mục nghỉ đứng đầu
      for (const d of duong) while (d.i < d.ds.length && d.ds[d.i]!.kieu === "nghi") { const m = d.ds[d.i] as MucNghiSv; d.san += (tren ? m.denS : m.tuS) * he; d.i++; }
      const cho = duong.filter((d) => d.i < d.ds.length);
      if (!cho.length) break;
      const x = cho.reduce((a, b) => (b.san < a.san ? b : a));
      const m = x.ds[x.i] as MucDoanSv;
      const bd = Math.max(bot, x.san);
      bot = bd + (hh(m.uocS) ? m.uocS : 0);
      x.san = bot; x.i++;
    }
    return Math.max(0, bot, ...duong.map((d) => d.san));
  };
  const vong = kh.lapCaSoDo ? soVongCaSoDo(kh.lapCaSoDo.soVong, nhap) : 1;
  const nghiVong = (tren: boolean): number => (kh.lapCaSoDo ? (tren ? kh.lapCaSoDo.denS : kh.lapCaSoDo.tuS) * he : 0);
  const tong = (tren: boolean): number => Math.round(mot(tren) * vong + nghiVong(tren) * (vong - 1));
  return { tuS: tong(false), denS: tong(true) };
}
/** Chữ tổng trên thanh công cụ canvas: "Cả sơ đồ ~25–40 phút · Chạy thử ~3 phút". Chưa có kế hoạch → "". */
export function chuTongUoc(d: Pick<ChiTietDoThiSv, "doThi">): string {
  const kh = d.doThi.keHoach;
  if (!kh?.duong.length) return "";
  const that = uocTongSoDo(kh), thu = uocTongSoDo(kh, { nhap: true });
  if (!that.denS) return "";
  const c = (u: { tuS: number; denS: number }): string => { const x = chuUoc(u); return x.startsWith("~") ? x : `~${x}`; };
  // (08/10/2026) "lặp cả sơ đồ tới HH:MM": lượt không bắt đầu vòng mới từ giờ đó (lần đầu tới sau lúc bắt đầu — trong vòng 1 ngày) → tổng vượt 1 ngày thì
  // chặn theo giờ dừng (Boss thật từng hiện "~145–168 giờ" cho ×20 tới 23:00).
  const denGio = kh.lapCaSoDo?.denGio ?? d.doThi.lapCaSoDo?.denGio;
  if (denGio && that.denS > 86_400) return `Cả sơ đồ ~1 ngày, tới ${denGio}`;
  return `Cả sơ đồ ${c(that)}`; // (08/10/2026, bỏ Nháp) không còn ước lượng "Chạy thử ~…"
}
/** Đưa lại một nút đã xoá (Hoàn tác) — giữ đúng mã cũ. */
export const dtKhoiPhucNut = (t: TrangDoThi, nut: NutDoThi): TrangDoThi | null => dtThemNut(t, nut);
export function dtDatCanh(t: TrangDoThi, canh: CanhDoThi[]): TrangDoThi | null {
  const ra = chuanHoaCanh(t.nut, canh).canh;
  const moi = { ...t, canh: ra };
  return khongDoi(t, moi) ? null : moi;
}
const suaNut = (t: TrangDoThi, id: string, f: (n: NutDoThi) => NutDoThi): TrangDoThi | null => {
  if (!t.nut.some((n) => n.id === id)) return null;
  const moi = { ...t, nut: t.nut.map((n) => (n.id === id ? f(sao(n)) : sao(n))), canh: sao(t.canh) };
  return khongDoi(t, moi) ? null : moi;
};
/** (đợt A) Đặt / bỏ (null) "Dành cho" của bước Nghỉ = mã một bước thuộc nhánh được gán. Không đổi → null. */
export const dtDatDanhCho = (t: TrangDoThi, id: string, danhCho: string | null): TrangDoThi | null => suaNut(t, id, (n) => { const { danhCho: _b, ...x } = n; return danhCho ? { ...x, danhCho } : x; });
/** (đợt A) Đặt / bỏ (null) tần suất của một bước việc. Không đổi → null. */
export const dtDatTanSuat = (t: TrangDoThi, id: string, ts: NutDoThi["tanSuat"] | null): TrangDoThi | null => suaNut(t, id, (n) => { const { tanSuat: _b, ...x } = n; return ts ? { ...x, tanSuat: { ...ts } } : x; });

// ---------------- (đợt A) HẸN GIỜ trên canvas (nút đỏ) ----------------
export interface HenGioNgan { hhmm: string; enabled: boolean; tuNgay?: string | null; denNgay?: string | null }
/** (đợt B1) Bot chọn được trong hộp hẹn giờ: máy chủ chỉ nhận bot CÙNG CHỦ với kịch bản (không thì 403) → chỉ liệt kê bot của chủ kịch bản (không rõ chủ → tài khoản đang đăng nhập). */
export function botChoHenGio<B extends { ownerId: string }>(bots: readonly B[], chuKichBan: string | undefined, uid: string): B[] {
  const chu = chuKichBan ?? uid;
  return bots.filter((b) => b.ownerId === chu);
}
const ngayCach = (a: string, b: string): number => Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86_400_000);
/** Chữ trên nút đỏ: chưa hẹn → "⏰ Hẹn giờ chạy"; đã hẹn → "⏰ 06:30 · 7 ngày · còn 5" (hẹn giờ bật sớm nhất; nhiều cái → "+n"). `homNay` = YYYY-MM-DD giờ VN. */
export function chuHenGio(ds: readonly HenGioNgan[], homNay: string): string {
  const bat = ds.filter((x) => x.enabled).sort((a, b) => a.hhmm.localeCompare(b.hhmm));
  if (!bat.length) return ds.length ? "⏰ Hẹn giờ chạy (đang tắt)" : "⏰ Hẹn giờ chạy";
  const a = bat[0]!;
  let chu = `⏰ ${a.hhmm}`;
  if (a.denNgay) {
    const tong = a.tuNgay ? ngayCach(a.tuNgay, a.denNgay) + 1 : null;
    const tu = a.tuNgay && a.tuNgay > homNay ? a.tuNgay : homNay; // chưa tới ngày bắt đầu → còn đủ số lần
    const con = Math.max(0, ngayCach(tu, a.denNgay) + 1);
    chu += `${tong ? ` · ${tong} ngày` : ""} · còn ${con}`;
  } else chu += " · mỗi ngày";
  return bat.length > 1 ? `${chu} · +${bat.length - 1}` : chu;
}
/** Kiểm ô của hộp hẹn giờ (trước khi gửi; máy chủ kiểm lại): lỗi tiếng Việt, rỗng = được. */
export function kiemHenGio(v: { hhmm: string; soNgay: string; dungLuc: string; lech: string; thu: number[]; botIds: string[] }): string[] {
  const loi: string[] = [];
  const gio = /^([01]\d|2[0-3]):[0-5]\d$/;
  if (!gio.test(v.hhmm.trim())) loi.push("Giờ bắt đầu phải có dạng HH:MM (00:00–23:59)");
  const so = v.soNgay.trim();
  if (!/^\d+$/.test(so) || Number(so) < 1 || Number(so) > 60) loi.push("Số ngày lặp lại phải là số nguyên 1–60");
  if (v.dungLuc.trim() && !gio.test(v.dungLuc.trim())) loi.push("Dừng lúc phải có dạng HH:MM (bỏ trống = không dừng cứng)");
  const l = v.lech.trim() || "0";
  if (!/^\d+$/.test(l) || Number(l) > 60) loi.push("Lệch ngẫu nhiên phải là số phút nguyên 0–60");
  if (!v.thu.length) loi.push("Chọn ít nhất một ngày trong tuần");
  if (!v.botIds.length) loi.push("Chưa chọn bot nào để chạy");
  return loi;
}
export function dtDoiNhuong(t: TrangDoThi, id: string): TrangDoThi | null {
  const mac = soDuong(t.nut, t.canh) >= 2;
  return suaNut(t, id, (n) => ({ ...n, nhuong: !(n.nhuong ?? mac) }));
}
export const dtDoiThamSo = (t: TrangDoThi, id: string, ten: string, giaTri: string): TrangDoThi | null => suaNut(t, id, (n) => ({ ...n, thamSo: { ...n.thamSo, [ten]: giaTri } }));
export const dtDoiNhieuThamSo = (t: TrangDoThi, id: string, doi: Record<string, string>): TrangDoThi | null => suaNut(t, id, (n) => ({ ...n, thamSo: { ...n.thamSo, ...doi } }));
export const dtTuDuyet = (t: TrangDoThi, id: string, bat: boolean): TrangDoThi | null => suaNut(t, id, (n) => { const { tuDuyet: _b, ...x } = n; return bat ? { ...x, tuDuyet: true } : x; });

/** Tạo nút MỚI với mã ổn định (so-do-sua.ts: n<số>, số chỉ tăng — không tái dùng mã đã xoá). Mạng khác mạng mặc định thì ghi trên nút. KHÔNG thêm vào trang (gọi dtThemNut). */
export function taoNutMoi(t: TrangDoThi, thaoTac: string, thamSo: Record<string, string>, nenTang?: string): NutDoThi {
  const sd = themNut({ id: "xx", ten: "", yeuCau: "", nenTang: t.nenTang, nut: sao(t.nut), ...(t.nutKe ? { nutKe: t.nutKe } : {}) }, thaoTac, thamSo);
  const moi = sd.nut[sd.nut.length - 1]!;
  return { id: moi.id, thaoTac, thamSo: { ...thamSo }, ...(nenTang && nenTang !== t.nenTang ? { nenTang } : {}) };
}

/** Đồ thị đang là MỘT đường MỘT mạng → nút theo thứ tự đường (bỏ nenTang / nhuong) để trả về danh sách thẻ; không thì null. */
export function motDuongMotMang(t: TrangDoThi): { nut: NutDoThi[]; nenTang: string } | null {
  const duong = tachDuong(t.nut, t.canh);
  if (duong.length !== 1) return null;
  if (duong[0]!.some((n) => (n.nenTang ?? t.nenTang) !== t.nenTang)) return null;
  return { nut: duong[0]!.map((n) => { const { nenTang: _m, nhuong: _h, ...x } = sao(n); return x; }), nenTang: t.nenTang };
}

// ================= CỜ THEO Ô =================
const them = (m: Map<string, CoNut[]>, id: string | undefined, c: CoNut): void => {
  if (!id) return;
  const a = m.get(id) ?? [];
  // (08/10/2026) một CÂU chỉ hiện một lần dù máy chủ báo ở hai nguồn (canhBaoBuoc đỏ + canhBaoDoan vàng của cùng đoạn) — giữ mức nặng hơn
  const cu = a.find((x) => x.loi === c.loi);
  if (!cu) a.push(c);
  else if (c.muc === "do") cu.muc = "do";
  m.set(id, a);
};
const nutDauCua = (d: Pick<ChiTietDoThiSv, "doThi">, doanId: string): string | undefined => {
  for (const du of d.doThi.keHoach?.duong ?? []) for (const m of du.muc) if (m.kieu === "doan" && m.doanId === doanId) return m.nutDau;
  return undefined;
};
const KHONG_CAT = new Set(["can_danh_sach", "dung_lai_danh_sach", "tu_khoa_tu_tim", "doi_cau_truc", "buoc_chen_cheo", "cham_lien_quan", "khoi_khong_khep_kin", "khong_phan_tich_duoc", "khong_nhuong_duoc"]);
const hoaDau = (s: string): string => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
/** Cờ theo ô từ chi tiết MÁY CHỦ: canhBaoBuoc (vàng + đỏ), thieuDauVao (nếu máy chủ chưa trả canhBaoBuoc), canhBaoDoThi (kèm cách sửa), canhBaoDoan. */
export function canhBaoTheoNut(d: ChiTietDoThiSv): Map<string, CoNut[]> {
  const m = new Map<string, CoNut[]>();
  for (const c of d.canhBaoBuoc ?? []) them(m, c.nutId, { muc: c.muc, loi: c.loi });
  for (const x of d.thieuDauVao ?? []) if (!(m.get(x.nutId) ?? []).some((c) => c.muc === "do")) them(m, x.nutId, { muc: "do", loi: `Bước ${x.soThuTu} (${x.tenNgan}): ${x.lyDo}` });
  for (const c of d.canhBaoDoThi ?? []) {
    // lý do KHÔNG cắt được tại ô Nghỉ (kiemCat): nói rõ "Nghỉ này không nhường được" ngay trên ô Nghỉ, kèm cách sửa
    const khongNhuong = KHONG_CAT.has(c.loai) && !/^Nghỉ này không nhường được/.test(c.lyDo);
    const lyDo = khongNhuong ? `Nghỉ này không nhường được — ${c.lyDo}` : c.lyDo;
    them(m, c.nutId, { muc: "vang", loi: c.cachSua ? `${lyDo} — Cách sửa: ${c.cachSua}` : lyDo });
  }
  for (const c of d.canhBaoDoan ?? []) them(m, c.nutId ?? nutDauCua(d, c.doanId), { muc: "vang", loi: c.noi });
  return m;
}
const chuKy = (n: NutDoThi): string => JSON.stringify([n.thaoTac, n.thamSo, n.nenTang ?? null]);
/** Cờ ĐANG HIỆN: ô chưa đổi so với bản máy chủ giữ cờ máy chủ; ô vừa thêm / vừa sửa (đang chờ lưu) tính cờ ĐỎ cục bộ theo ô bắt buộc còn trống (máy chủ trả lời thì thay). */
export function canhBaoHienThi(t: TrangDoThi, d: ChiTietDoThiSv, banDo: BanDoWeb | null | undefined): Map<string, CoNut[]> {
  const sv = canhBaoTheoNut(d);
  const goc = new Map(d.doThi.nut.map((n) => [n.id, n] as const));
  const ra = new Map<string, CoNut[]>();
  for (const n of t.nut) {
    const cu = goc.get(n.id);
    if (cu && chuKy(cu) === chuKy(n)) { const c = sv.get(n.id); if (c?.length) ra.set(n.id, c.map((x) => ({ ...x }))); continue; }
    const thieu = thamSoThieuCua(banDo, t.nenTang, n);
    if (thieu.length) ra.set(n.id, thieu.map((x) => ({ muc: "do" as const, loi: `${tenNutCua(banDo, t.nenTang, n)}: ${hoaDau(x.lyDo)}` })));
  }
  return ra;
}

// ================= THANH CẢNH BÁO TỔNG THEO ĐOẠN =================
export const nhanDoanCua = (m: Pick<MucDoanSv, "nenTang" | "thuTu">, banDo: BanDoWeb | null | undefined): string => `${tenMangCua(banDo, m.nenTang)} · đoạn ${m.thuTu}`;
export interface NhomCo { nhan: string; doanId: string | null; nutDo: string[]; nutVang: string[]; ds: { nutId: string; ten: string; muc: "vang" | "do" }[] }
export function tongCoTheoDoan(co: Map<string, CoNut[]>, d: ChiTietDoThiSv, banDo: BanDoWeb | null | undefined, nut: NutDoThi[] = d.doThi.nut): { do: number; vang: number; nhom: NhomCo[] } {
  const mucCua = (id: string): "vang" | "do" | null => { const c = co.get(id); return c?.length ? (c.some((x) => x.muc === "do") ? "do" : "vang") : null; };
  const theoId = new Map(nut.map((n) => [n.id, n] as const));
  const daXep = new Set<string>();
  const nhom: NhomCo[] = [];
  const them1 = (g: NhomCo, id: string): void => {
    const muc = mucCua(id), n = theoId.get(id);
    if (!muc || !n || daXep.has(id)) return;
    daXep.add(id);
    (muc === "do" ? g.nutDo : g.nutVang).push(id);
    g.ds.push({ nutId: id, ten: tenNutCua(banDo, d.doThi.nenTang, n), muc });
  };
  for (const du of d.doThi.keHoach?.duong ?? []) for (const m of du.muc) {
    if (m.kieu !== "doan") continue;
    const g: NhomCo = { nhan: nhanDoanCua(m, banDo), doanId: m.doanId, nutDo: [], nutVang: [], ds: [] };
    for (const id of m.nutIds) them1(g, id);
    if (g.ds.length) nhom.push(g);
  }
  const nghi: NhomCo = { nhan: "Ô Nghỉ", doanId: null, nutDo: [], nutVang: [], ds: [] };
  const khac: NhomCo = { nhan: "Chưa vào kế hoạch (đang lưu)", doanId: null, nutDo: [], nutVang: [], ds: [] };
  for (const n of nut) { if (daXep.has(n.id)) continue; them1(laNghiCua(banDo, d.doThi.nenTang, n) ? nghi : khac, n.id); }
  for (const g of [nghi, khac]) if (g.ds.length) nhom.push(g);
  return { do: nhom.reduce((s, g) => s + g.nutDo.length, 0), vang: nhom.reduce((s, g) => s + g.nutVang.length, 0), nhom };
}
/** Đọc 400 { details.buocDo } của máy chủ (còn ô đỏ) thành các dòng "Bước n (Tên): lý do". Không đúng dạng → null. */
export function buocDoTuLoiMayChu(e: unknown): { soThuTu: number; tieuDe: string; loi: string }[] | null {
  const det = (e as { details?: unknown } | null)?.details;
  if (!det || typeof det !== "object") return null;
  const b = (det as { buocDo?: { soThuTu: number; tenNgan: string; lyDo: string }[] }).buocDo;
  return Array.isArray(b) && b.length ? b.map((x) => ({ soThuTu: x.soThuTu, tieuDe: x.tenNgan, loi: `Bước ${x.soThuTu} (${x.tenNgan}): ${x.lyDo}` })) : null;
}

/**
 * 409 của chạy thật lượt (máy chủ THẬT, luot-do-thi-api.ts congChayThatDoan): code "conflict" + details { doan[], canChoPhep } — canChoPhep = true khi MỌI đoạn đã chạy thử sạch và chỉ còn thiếu
 * "được phép chạy thật" → hiện nút "Cho phép chạy thật". Chưa chạy thử sạch → code "not_dried", canChoPhep = false → KHÔNG hiện nút (cho phép cũng chưa chạy được).
 * Chỉ tin cờ canChoPhep === true (đúng kiểu boolean) trên lỗi 409 conflict; mọi dạng khác → false.
 */
export function canChoPhepTuLoiMayChu(e: unknown): boolean {
  if (!e || typeof e !== "object") return false;
  const o = e as { code?: unknown; details?: unknown };
  const det = o.details;
  if (o.code !== "conflict" || !det || typeof det !== "object") return false;
  return (det as { canChoPhep?: unknown }).canChoPhep === true;
}
/** Câu diễn giải của lượt (máy chủ) nói "đường “duong-n1”" → "Đường 1" theo thứ tự đường trong lượt (cùng cách thẻ tiến độ gọi "Đường 1"); mã lạ giữ nguyên. */
export function lamDepDienGiai(chu: string, duongIds: string[], nhanh?: (maDuong: string) => string | null): string {
  if (typeof chu !== "string") return "";
  // (đợt B3) "nhánh “duong-n4”" cũng không được lộ mã: biết thứ tự đường → "Đường 2"; có nơi gọi biết sơ đồ → "nhánh YouTube (bước 4)"; còn lại "nhánh (bước 4)".
  return chu.replace(/(đường|Đường|nhánh|Nhánh) “([^”]*)”/g, (nguyen, tu: string, ma: string) => {
    const i = duongIds.indexOf(ma);
    if (/^(đường|Đường)$/.test(tu)) return i >= 0 ? `Đường ${i + 1}` : nguyen;
    if (!/^duong-/.test(ma)) return nguyen;
    return nhanh?.(ma) ?? (i >= 0 ? `Đường ${i + 1}` : nhanNhanh(ma));
  });
}
/** Mã đoạn của SƠ ĐỒ ("doan-f1" — máy chủ trả trong lượt) → "Facebook · đoạn 1" theo kế hoạch dự kiến; không thấy → "". */
export function nhanDoanTheoMa(duong: DuongSv[], doanId: string, banDo: BanDoWeb | null | undefined): string {
  for (const du of duong ?? []) for (const m of du.muc) if (m.kieu === "doan" && m.doanId === doanId) return nhanDoanCua(m, banDo);
  return "";
}

// ================= KẾ HOẠCH DỰ KIẾN / CHẠY THỬ / NHÃN =================
export function dinhDangGiay(s: number): string {
  if (!hh(s) || s < 0) return "";
  const t = Math.round(s);
  if (t < 60) return `${t} giây`;
  if (t < 3600) { const p = Math.floor(t / 60), g = t % 60; return g ? `${p} phút ${g} giây` : `${p} phút`; }
  const gio = Math.floor(t / 3600), p = Math.floor((t % 3600) / 60);
  return p ? `${gio} giờ ${p} phút` : `${gio} giờ`;
}
// (08/10/2026, bỏ Nháp) chip theo đoạn = kết quả LẦN CHẠY GẦN NHẤT; "chưa chạy" / "đã sửa" không còn đòi chạy thử lại (không hiện chip).
const CHU_CHAY_THU: Record<string, string> = { sach: "Lần chạy gần nhất đạt", loi: "Lần chạy gần nhất lỗi", dang: "Đang chạy" };
export const chipChayThu = (ketQua: string): string => CHU_CHAY_THU[ketQua] ?? "";
const chuNghi = (tuS: number, denS: number): string => {
  const f = (x: number): string => (x < 120 ? String(x) : dinhDangGiay(x));
  const dv = Math.max(tuS, denS) < 120 ? " giây" : "";
  return tuS === denS ? `Nghỉ ${dinhDangGiay(tuS)}` : `Nghỉ ${f(tuS)}–${f(denS)}${dv}`;
};
export interface MucHienThi { kieu: "doan" | "nghi" | "lap"; chu: string; uoc: string; chip: string | null; doanId?: string; nutIds?: string[]; nutId?: string }
export interface DuongHienThi { id: string; ten: string; muc: MucHienThi[] }
export function keHoachHienThi(d: ChiTietDoThiSv, banDo: BanDoWeb | null | undefined): DuongHienThi[] {
  return (d.doThi.keHoach?.duong ?? []).map((du, i) => ({
    id: du.id, ten: `Đường ${i + 1}`,
    muc: du.muc.map((m, j): MucHienThi => {
      if (m.kieu === "nghi") return { kieu: "nghi", chu: chuNghi(m.tuS, m.denS), uoc: "", chip: null, nutId: m.nutId };
      if (m.kieu === "lap") {
        const dau = du.muc[m.veMuc];
        const ten = dau?.kieu === "doan" ? nhanDoanCua(dau, banDo) : dau?.kieu === "nghi" ? chuNghi(dau.tuS, dau.denS) : "bước trước";
        const mot = uocTongSoDo({ duong: [{ id: du.id, muc: du.muc.slice(m.veMuc, j).filter((x) => x.kieu !== "lap") }] });
        const chuMot = chuUoc(mot);
        // (08/10/2026) vòng "lặp tới khi hết bước Nghỉ": số vòng do Nghỉ dành cho nhánh quyết — không nêu ×soLan / tổng vòng.
        const chuVong = m.denHetNghi ? `lặp tới khi hết Nghỉ${m.denGio ? `, dừng sớm khi tới ${m.denGio}` : ""}` : `làm thêm ×${m.soLan} (tổng ${m.soLan + 1} vòng${m.denGio ? `, dừng sớm khi tới ${m.denGio}` : ""})`;
        return { kieu: "lap", chu: `↺ Quay lại «${ten}» ${chuVong}`, uoc: mot.denS ? `mỗi vòng ${chuMot.startsWith("~") ? chuMot : `~${chuMot}`}` : "", chip: null, nutId: m.tu };
      }
      return { kieu: "doan", chu: nhanDoanCua(m, banDo), uoc: m.uocS !== undefined && dinhDangGiay(m.uocS) ? `khoảng ${dinhDangGiay(m.uocS)}` : "", chip: chipChayThu(m.chayThu.ketQua), doanId: m.doanId, nutIds: m.nutIds };
    }),
  }));
}
export function mucHienTaiChu(duong: DuongSv | undefined, muc: number, banDo: BanDoWeb | null | undefined): string {
  const m = duong?.muc[muc];
  if (!m) return "";
  return m.kieu === "nghi" ? chuNghi(m.tuS, m.denS) : m.kieu === "lap" ? "quay lại vòng sau" : nhanDoanCua(m, banDo);
}
const CHU_KQ_NUT: Record<string, string> = { ok: "đạt", loi: "lỗi", nhap: "nháp (chỉ ghi lại, chưa làm thật)", bo_qua: "bỏ qua", chua: "chưa chạy tới" };
export function ketQuaNutHienThi(d: ChiTietDoThiSv, banDo: BanDoWeb | null | undefined, nut: NutDoThi[] = d.doThi.nut): { nutId: string; ten: string; chu: string; trangThai: string }[] {
  const ra: { nutId: string; ten: string; chu: string; trangThai: string }[] = [];
  for (const n of nut) {
    const k = d.doThi.ketQuaNut[n.id];
    if (!k) continue;
    ra.push({ nutId: n.id, ten: tenNutCua(banDo, d.doThi.nenTang, n), trangThai: k.trangThai, chu: `${CHU_KQ_NUT[k.trangThai] ?? k.trangThai}${k.trangThai === "loi" && k.lyDo ? ` — ${k.lyDo}` : ""}` });
  }
  return ra;
}
/** Nhãn "lần n" của ô: đếm theo từng ĐOẠN (mỗi đoạn là một kịch bản con — số lần tính lại từ 1); ô Nghỉ, ô lần 1, ô ngoài đoạn → null. */
export function danhNhanTheoNut(d: Pick<ChiTietDoThiSv, "doThi">): Map<string, string | null> {
  const ra = new Map<string, string | null>(d.doThi.nut.map((n) => [n.id, null] as const));
  const theoId = new Map(d.doThi.nut.map((n) => [n.id, n] as const));
  for (const du of d.doThi.keHoach?.duong ?? []) for (const m of du.muc) {
    if (m.kieu !== "doan") continue;
    const dem = new Map<string, number>();
    for (const id of m.nutIds) {
      const n = theoId.get(id);
      if (!n || n.thaoTac === "nghi") continue;
      const lan = (dem.get(n.thaoTac) ?? 0) + 1;
      dem.set(n.thaoTac, lan);
      ra.set(id, lan >= 2 ? `lần ${lan}` : null);
    }
  }
  return ra;
}
/** "Tìm bài viết (lần 2)" khi cần tên đầy đủ cho danh sách. */
export const tenCoLan = (ten: string, nhan: string | null | undefined): string => { const m = /(\d+)/.exec(nhan ?? ""); return m ? nhanLan(ten, Number(m[1])) : ten; };

// ================= LƯỢT: CHỮ TRẠNG THÁI =================
const CHU_DUONG: Record<string, string> = { cho_dau: "chờ tới lượt", san_sang: "sẵn sàng", dang_chay: "đang chạy", hen_gio: "đang nghỉ", cho_bot: "chờ bot rảnh", cho_nguoi: "chờ người xử lý", cho_o_nghi: "chờ bước Nghỉ dành riêng", xong: "xong", loi: "lỗi", da_dung: "đã dừng", khong_chay: "không chạy" };
export const chuTrangThaiDuong = (s: string): string => CHU_DUONG[s] ?? s;
const CHU_LUOT: Record<string, string> = { dang_chay: "đang chạy", xong: "xong", xong_co_loi: "xong, có đường lỗi", da_dung: "đã dừng", dung_vi_loi: "dừng vì lỗi" };
export const chuTrangThaiLuot = (s: string): string => CHU_LUOT[s] ?? s;

// ================= VIỆC A (07/10/2026): thẻ chạy lượt NHIỀU BOT =================
/** Chữ nút chạy theo số bot đã tick: 0–1 bot giữ chữ cũ, ≥ 2 bot nói rõ N bot. */
/** (08/10/2026, người dùng bỏ Nháp — "chỉ có 1 nút chạy") MỘT nút chạy thật; tham số cheDo giữ cho chỗ gọi cũ (draft → cùng chữ). */
export function nhanNutLuot(_cheDo: "draft" | "live", soBot: number): string {
  return soBot >= 2 ? `▶ Chạy trên ${soBot} bot` : "▶ Chạy";
}
/** Khoá nút chạy: chưa tick / đang gửi → khoá; đúng 1 bot → bot phải còn, trực tuyến và chưa chạy lượt này; ≥ 2 bot → máy chủ xét từng bot (chỉ khoá khi mọi bot đã tick đều đang chạy lượt này). */
export function khoaNutLuot(a: { chon: string[]; bots: { id: string; online: boolean }[]; dangGui: boolean; botDangChayLuot: Set<string> }): boolean {
  if (a.dangGui || !a.chon.length) return true;
  if (a.chon.length >= 2) return a.chon.every((id) => a.botDangChayLuot.has(id));
  const b = a.bots.find((x) => x.id === a.chon[0]);
  return !b || !b.online || a.botDangChayLuot.has(b.id);
}
/**
 * (08/10/2026, A4) ▶ Chạy phải TẮT khi màn hình còn khác bản đã lưu: việc còn chờ / đang lưu / chờ thử lại, hoặc một ô nhập đang giữ giá trị máy chủ vừa từ chối ("abc") — nếu không máy chạy bản đã lưu CŨ
 * trong khi màn hình hiện giá trị mới. `hienDong`: false = chỉ chớp ngắn lúc đang lưu (nút tắt, chưa cần nói lý do). null = chạy được.
 * `tenOSai`: nhãn các ô còn giữ giá trị bị từ chối. Trạng thái "loi" mà màn hình đã khớp bản lưu (canvas đã trả về như trước) KHÔNG tắt: chạy đúng cái đang thấy.
 */
export function lyDoChuaLuuDoThi(a: { trangThai: TrangThaiLuuDt; coThayDoi: boolean; tenOSai: string[] }): { lyDo: string; hienDong: boolean } | null {
  const CAU = "Còn thay đổi chưa lưu — bấm Lưu hoặc Thử lưu lại trước khi chạy";
  if (a.tenOSai.length) {
    const ds = a.tenOSai.slice(0, 3).map((t) => `“${t}”`).join(", ") + (a.tenOSai.length > 3 ? ` và ${a.tenOSai.length - 3} ô khác` : "");
    return { lyDo: `Còn thay đổi chưa lưu — ${a.tenOSai.length > 1 ? "các ô" : "ô"} ${ds} đang giữ giá trị máy chủ không nhận: sửa lại cho đúng (hoặc gõ lại giá trị cũ) rồi mới chạy`, hienDong: true };
  }
  if (a.trangThai === "loi-thu-lai") return { lyDo: CAU, hienDong: true };
  if (a.coThayDoi || a.trangThai === "cho-luu" || a.trangThai === "dang-luu") return { lyDo: CAU, hienDong: false };
  return null;
}
export type ChoLuotWeb = { kieu: "lech"; batDauLuc: string } | { kieu: "thu_truoc"; luotId: string; botId: string | null };
/** Lượt đang CHỜ bắt đầu → câu ngắn cho dòng của bot ("" khi không chờ). */
export function chuChoLuot(cho: ChoLuotWeb | null | undefined, tenBot: (id: string) => string, now = Date.now()): string {
  if (!cho) return "";
  if (cho.kieu === "thu_truoc") { const t = cho.botId ? tenBot(cho.botId) : ""; return t ? `chờ bot “${t}” chạy trước xong sạch` : "chờ bot chạy trước xong sạch"; }
  const con = Math.round((Date.parse(cho.batDauLuc) - now) / 1000);
  return con > 0 ? `chờ bắt đầu lệch nhau — còn ${dinhDangGiay(con)}` : "chờ bắt đầu lệch nhau — sắp bắt đầu";
}
/** Bảng tiến độ từng bot = lượt của nhóm nhiều bot mới nhất + lượt đang chạy (bản đang chạy thay bản trong nhóm cùng mã), không trùng. */
export function bangTienDoBot<T extends { id: string }>(dangChay: T[], nhom: T[]): T[] {
  const moi = new Map(dangChay.map((x) => [x.id, x] as const));
  const ra = nhom.map((x) => moi.get(x.id) ?? x);
  for (const x of dangChay) if (!ra.some((y) => y.id === x.id)) ra.push(x);
  return ra;
}

// ================= HÀNG ĐỢI LƯU ĐỒ THỊ =================
/** `tam` (08/10/2026): lỗi TẠM (500 / mất mạng / máy chủ không trả lời) → hàng đợi GIỮ thay đổi và tự thử lại; không có = máy chủ từ chối nội dung (400…) → bỏ lô. */
export type KetQuaGuiDt = { ok: true; trang: TrangDoThi; phienBan: number } | { ok: false; loi: unknown; xungDot?: boolean; tam?: boolean };
/** Trạng thái lưu cho chỉ báo trên thanh công cụ canvas. */
export type TrangThaiLuuDt = "da-luu" | "cho-luu" | "dang-luu" | "loi-thu-lai" | "loi";
/** Lỗi gọi API là lỗi TẠM? (mất mạng / máy chủ 5xx / không phải lỗi API có mã) — 4xx là máy chủ từ chối nội dung. */
export function laLoiTam(e: unknown): boolean {
  if (!e || typeof e !== "object") return true;
  const x = e as { code?: unknown; status?: unknown };
  if (x.code === "network" || x.code === "internal") return true;
  if (typeof x.status === "number" && x.status >= 500) return true;
  return typeof x.code !== "string";
}
export interface ViecDoThi {
  lam: (t: TrangDoThi) => TrangDoThi | null;
  ten?: string;
  /** Lô chứa việc này được máy chủ nhận / từ chối (mỗi việc trong lô đều được gọi). */
  xong?: () => void;
  loi?: (e: unknown) => void;
}
export interface TuyChonHangDoi {
  xacNhan: TrangDoThi;
  phienBan: number;
  gui: (t: TrangDoThi, phienBan: number) => Promise<KetQuaGuiDt>;
  /** Bản đang hiện có thể đã đổi (thêm việc / có kết quả): trang vẽ lại canvas + chấm "đang lưu". */
  khiDoi?: () => void;
  /** `tam`: lỗi tạm — thay đổi được GIỮ, sẽ tự thử lại sau `thuLaiSauMs`. `viec`: tên các việc chưa lưu (409: mọi việc bị bỏ). */
  khiLoi?: (e: unknown, ctx: { xungDot: boolean; viec: string[]; tam?: boolean; thuLaiSauMs?: number }) => void;
  khiXong?: () => void;
  /** Hẹn giờ thử lại (thử nghiệm tiêm đồng hồ giả); trả hàm huỷ. Mặc định setTimeout. */
  henThuLai?: (ms: number, fn: () => void) => () => void;
  /** Lịch lùi dần (ms) — lần lỗi thứ k dùng phần tử k (hết danh sách thì giữ mốc cuối). */
  lichThuLai?: number[];
}
const LICH_THU_LAI_MAC_DINH = [2000, 4000, 8000, 15000, 30000];
/**
 * Lưu đồ thị LẠC QUAN, TUẦN TỰ, GOM THEO NHỊP: mỗi thao tác hiện NGAY (hienThi = các việc chờ áp lên bản đã lưu); việc cùng một nhịp (thêm ô rồi nối cạnh — canvas gọi hai hàm liền nhau) gom thành MỘT lần
 * gửi (không bao giờ gửi đồ thị nửa vời: thêm ô khi đã đủ 6 đường sẽ bị 400 nếu gửi riêng). Lần gửi sau luôn dùng phiên bản MỚI do lần trước trả về (không 409 giả). Máy chủ từ chối (400 / mất mạng)
 * → bỏ đúng lô bị từ chối, các việc đến sau được dựng lại trên bản đã lưu; 409 → bỏ mọi việc chờ (trang tải lại).
 */
export class HangDoiDoThi {
  private xn: TrangDoThi;
  private pb: number;
  private cho: ViecDoThi[] = [];
  private chay: Promise<void> | null = null;
  private hen: ReturnType<typeof setTimeout> | null = null;
  private huyThuLai: (() => void) | null = null; // đang chờ thử lại sau lỗi tạm
  private lanLoi = 0;
  private dangGui = false; // đang chờ máy chủ trả lời (đặt TRƯỚC khi `chay` được gán — vong() chạy đồng bộ tới lần await đầu)
  private loiCuoi: "tam" | "tu-choi" | null = null;
  private luc: number | null = null;
  constructor(private readonly o: TuyChonHangDoi) { this.xn = sao(o.xacNhan); this.pb = o.phienBan; }
  /** Còn thay đổi chưa lên máy chủ (đang chờ / đang gửi / chờ thử lại). */
  get coThayDoi(): boolean { return this.cho.length > 0; }
  /** Giờ (ms) lần lưu thành công gần nhất trong phiên trang; null = chưa lưu lần nào. */
  get luuLuc(): number | null { return this.luc; }
  get trangThai(): TrangThaiLuuDt {
    if (this.chay || this.dangGui) return "dang-luu";
    if (this.huyThuLai && this.cho.length) return "loi-thu-lai";
    if (this.cho.length) return "cho-luu";
    return this.loiCuoi === "tu-choi" ? "loi" : "da-luu";
  }
  get xacNhan(): TrangDoThi { return this.xn; }
  get phienBan(): number { return this.pb; }
  get ban(): boolean { return this.cho.length > 0 || this.chay !== null; }
  get soCho(): number { return this.cho.length; }
  hienThi(): TrangDoThi {
    let t = this.xn;
    for (const v of this.cho) t = v.lam(t) ?? t;
    return t;
  }
  them(v: ViecDoThi): boolean {
    const moi = v.lam(this.hienThi());
    if (!moi) return false;
    this.cho.push(v);
    if (!this.chay && !this.hen && !this.huyThuLai) this.hen = setTimeout(() => { this.hen = null; this.batDau(); }, 0); // đang chờ thử lại: việc mới đi cùng lần thử lại
    this.o.khiDoi?.();
    return true;
  }
  datXacNhan(t: TrangDoThi, phienBan: number): void { this.xn = sao(t); this.pb = phienBan; }
  async choXong(): Promise<void> {
    if (this.hen) { clearTimeout(this.hen); this.hen = null; this.batDau(); }
    while (this.chay) await this.chay;
  }
  /** Nút "Lưu": gửi NGAY mọi thay đổi đang chờ (kể cả lúc đang chờ thử lại — huỷ hẹn đó); không có gì → không gửi. Gọi nhiều lần liên tiếp = một lần gửi. */
  async luuNgay(): Promise<void> {
    if (this.huyThuLai) { this.huyThuLai(); this.huyThuLai = null; if (this.cho.length) this.batDau(); }
    await this.choXong();
  }
  /** Trang thấy màn hình đã khớp bản đã lưu (gõ lại đúng giá trị đang lưu sau khi bị từ chối) → bỏ trạng thái "Chưa lưu được"; còn việc chờ thì giữ nguyên. */
  boQuaLoi(): void { if (!this.cho.length && this.loiCuoi === "tu-choi") this.loiCuoi = null; }
  huy(): void { if (this.hen) { clearTimeout(this.hen); this.hen = null; } if (this.huyThuLai) { this.huyThuLai(); this.huyThuLai = null; } this.cho = []; }
  private henLai(): number {
    const lich = this.o.lichThuLai?.length ? this.o.lichThuLai : LICH_THU_LAI_MAC_DINH;
    const ms = lich[Math.min(this.lanLoi, lich.length - 1)]!;
    this.lanLoi++;
    const chay = (): void => { this.huyThuLai = null; this.batDau(); };
    if (this.o.henThuLai) this.huyThuLai = this.o.henThuLai(ms, chay);
    else { const t = setTimeout(chay, ms); this.huyThuLai = () => clearTimeout(t); }
    return ms;
  }
  /** `khiDoi` gọi thêm MỘT lần sau khi hàng đợi đã rảnh hẳn (lúc khiXong / khiLoi chạy, `ban` còn true) — chấm "Đang lưu…" mới tắt được. */
  private batDau(): void { if (!this.chay) this.chay = this.vong().finally(() => { this.chay = null; try { this.o.khiDoi?.(); } catch { /* trang tự lo */ } }); }
  private async vong(): Promise<void> {
    while (this.cho.length) {
      const n = this.cho.length;
      const lo = this.cho.slice(0, n);
      let thu = this.xn;
      for (const v of lo) thu = v.lam(thu) ?? thu;
      if (trangBangNhau(thu, this.xn)) { // việc tự triệt tiêu: màn hình = bản đã lưu → coi như đã lưu (hết trạng thái lỗi cũ)
        this.cho.splice(0, n); this.loiCuoi = null; this.lanLoi = 0;
        try { for (const v of lo) v.xong?.(); this.o.khiXong?.(); } finally { this.o.khiDoi?.(); }
        continue;
      }
      let kq: KetQuaGuiDt;
      this.dangGui = true;
      try { this.o.khiDoi?.(); } catch { /* trang tự lo */ } // chỉ báo chuyển sang "Đang lưu…" đúng lúc gửi
      try { kq = await this.o.gui(sao(thu), this.pb); } catch (e) { kq = { ok: false, loi: e, tam: true }; } finally { this.dangGui = false; } // ném = mất mạng / lỗi không lường → coi là tạm
      if (kq.ok) {
        this.cho.splice(0, n);
        this.lanLoi = 0; this.loiCuoi = null; this.luc = Date.now();
        const ke = Math.max(kq.trang.nutKe ?? 0, thu.nutKe ?? 0, this.xn.nutKe ?? 0);
        this.xn = { ...sao(kq.trang), ...(ke > 1 ? { nutKe: ke } : {}) };
        this.pb = kq.phienBan;
        try { for (const v of lo) v.xong?.(); this.o.khiXong?.(); } finally { this.o.khiDoi?.(); }
        continue;
      }
      const xungDot = !!kq.xungDot;
      if (kq.tam && !xungDot) {
        // (08/10/2026) lỗi TẠM: KHÔNG bỏ gì — mọi việc (cả việc đến sau) còn nguyên trên trang, tự thử lại lùi dần; dừng vòng tới lúc hẹn
        this.loiCuoi = "tam";
        const ms = this.henLai();
        try { this.o.khiLoi?.(kq.loi, { xungDot: false, viec: this.cho.map((v) => v.ten ?? ""), tam: true, thuLaiSauMs: ms }); } finally { this.o.khiDoi?.(); }
        return;
      }
      const boViec = xungDot ? this.cho.slice() : lo;
      if (xungDot) this.cho = []; else this.cho.splice(0, n);
      this.loiCuoi = "tu-choi"; this.lanLoi = 0;
      try { for (const v of lo) v.loi?.(kq.loi); this.o.khiLoi?.(kq.loi, { xungDot, viec: boViec.map((v) => v.ten ?? ""), tam: false }); } finally { this.o.khiDoi?.(); }
    }
  }
}

// ================= LƯU BỐ CỤC (debounce) =================
/** Gom các lần kéo ô: sau `ms` (mặc định 500) không có thay đổi mới mới gửi, chỉ gồm ô đổi so với bản đã biết. Gửi hỏng → báo, bản đã biết giữ nguyên (lần đổi sau gửi lại cả phần chưa lên). */
export class LuuBoCuc {
  private biet: BoCucTrang;
  private cho: BoCucTrang | null = null;
  private hen: ReturnType<typeof setTimeout> | null = null;
  private dangGui: Promise<void> | null = null;
  constructor(private readonly o: { biet?: BoCucTrang; gui: (nut: BoCucTrang) => Promise<void>; ms?: number; khiLoi?: (e: unknown) => void }) { this.biet = sao(o.biet ?? {}); }
  datBiet(bc: BoCucTrang): void { this.biet = sao(bc); }
  dat(bc: BoCucTrang): void {
    const sach: BoCucTrang = {};
    for (const [id, p] of Object.entries(bc ?? {})) if (hh(p?.x) && hh(p?.y)) sach[id] = { x: p.x, y: p.y };
    this.cho = sach;
    if (this.hen) clearTimeout(this.hen);
    this.hen = setTimeout(() => { this.hen = null; void this.xa(); }, this.o.ms ?? 500);
  }
  /** Phần đang chờ gửi so với bản đã biết (không lấy ra); không có gì → null. Dùng khi rời trang. */
  layDoi(): BoCucTrang | null {
    if (!this.cho) return null;
    const doi: BoCucTrang = {};
    for (const [id, p] of Object.entries(this.cho)) { const b = this.biet[id]; if (!b || b.x !== p.x || b.y !== p.y) doi[id] = { ...p }; }
    return Object.keys(doi).length ? doi : null;
  }
  async xa(): Promise<void> {
    if (this.hen) { clearTimeout(this.hen); this.hen = null; }
    while (this.dangGui) await this.dangGui;
    const cho = this.cho;
    this.cho = null;
    if (!cho) return;
    const doi: BoCucTrang = {};
    for (const [id, p] of Object.entries(cho)) { const b = this.biet[id]; if (!b || b.x !== p.x || b.y !== p.y) doi[id] = p; }
    if (!Object.keys(doi).length) return;
    this.dangGui = (async () => {
      try { await this.o.gui(doi); this.biet = { ...this.biet, ...sao(doi) }; } catch (e) { try { this.o.khiLoi?.(e); } catch { /* không để lỗi báo lỗi làm hỏng */ } }
    })();
    try { await this.dangGui; } finally { this.dangGui = null; }
  }
  huy(): void { if (this.hen) { clearTimeout(this.hen); this.hen = null; } this.cho = null; }
}
